export interface ElementTypes {
  button: string;
  anchorTag: string;
}

export const elementTypes: ElementTypes = {
  button: 'button',
  anchorTag: 'a'
};
